import { render, staticRenderFns } from "./TheMenuBasket.vue?vue&type=template&id=733e4ea7&scoped=true"
import script from "./TheMenuBasket.ts?vue&type=script&lang=ts&external"
export * from "./TheMenuBasket.ts?vue&type=script&lang=ts&external"
import style0 from "./TheMenuBasket.vue?vue&type=style&index=0&id=733e4ea7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e4ea7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDivider,VIcon,VSpacer,VSubheader})
